var _ellipse, _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobilePostEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65,
    cy: 65.0862,
    rx: 60,
    ry: 60,
    transform: "rotate(-180 65 65.0862)",
    fill: "url(#paint0_linear_641_6822)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_641_6822)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.4883,
    y: 24.3359,
    width: 82.0513,
    height: 82.0513,
    rx: 41.0256,
    fill: "#5449C5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1866 48.4387H69.1031C70.7987 48.4387 72.1665 48.4387 73.2797 48.5146C74.4243 48.5927 75.4365 48.7574 76.3949 49.1544C78.6985 50.1086 80.5288 51.9389 81.483 54.2426C81.88 55.201 82.0447 56.2131 82.1228 57.3578C82.1987 58.4709 82.1987 59.8387 82.1987 61.5343V61.6679C82.1987 63.3635 82.1987 64.7313 82.1228 65.8445C82.0447 66.9891 81.88 68.0013 81.483 68.9597C80.5288 71.2634 78.6985 73.0936 76.3949 74.0478C75.4365 74.4448 74.4243 74.6095 73.2797 74.6876C72.1665 74.7635 70.7987 74.7635 69.1031 74.7635H64.2011C63.337 74.7635 63.1647 74.7722 63.0241 74.8005C62.6966 74.8665 62.3926 75.0185 62.1433 75.2409C62.0363 75.3364 61.926 75.469 61.4075 76.1603L61.367 76.2143C60.228 77.733 59.3204 78.9432 58.5777 79.8181C57.8795 80.6405 57.0904 81.4677 56.1486 81.857C53.5571 82.9283 50.5721 81.9333 49.1416 79.5214C48.6218 78.6448 48.4868 77.5096 48.4217 76.4328C48.3525 75.2872 48.3525 73.7745 48.3525 71.8763V62.2728C48.3525 60.2349 48.3525 58.5912 48.4613 57.2601C48.5732 55.8896 48.8098 54.6859 49.3773 53.5721C50.2786 51.8031 51.7169 50.3648 53.486 49.4634C54.5997 48.896 55.8034 48.6594 57.1739 48.5474C58.505 48.4387 60.1487 48.4387 62.1866 48.4387ZM57.4802 52.2956C56.3422 52.3886 55.6885 52.5619 55.1933 52.8142C54.1318 53.3551 53.2689 54.218 52.7281 55.2795C52.4757 55.7747 52.3024 56.4284 52.2095 57.5664C52.1147 58.7262 52.1132 60.216 52.1132 62.3532V71.8087C52.1132 73.7897 52.1141 75.1879 52.1756 76.206C52.206 76.7097 52.2485 77.0638 52.2985 77.3133C52.3409 77.5247 52.3778 77.604 52.3799 77.6091C52.8569 78.4066 53.8452 78.7361 54.7054 78.3842C54.7101 78.3814 54.7872 78.3402 54.948 78.1964C55.1376 78.0268 55.3841 77.7691 55.7107 77.3844C56.3707 76.6068 57.2103 75.4887 58.3989 73.9039C58.4262 73.8676 58.4532 73.8315 58.48 73.7958C58.8717 73.2726 59.2159 72.8129 59.6394 72.435C60.3872 71.7677 61.2992 71.3117 62.2817 71.1138C62.8381 71.0018 63.4124 71.0022 64.066 71.0028C64.1107 71.0028 64.1557 71.0028 64.2011 71.0028H69.0363C70.8143 71.0028 72.0536 71.0018 73.0237 70.9356C73.9768 70.8706 74.5319 70.749 74.9557 70.5734C76.3379 70.0009 77.4361 68.9027 78.0086 67.5205C78.1842 67.0967 78.3058 66.5416 78.3708 65.5885C78.437 64.6184 78.438 63.3791 78.438 61.6011C78.438 59.8231 78.437 58.5838 78.3708 57.6138C78.3058 56.6606 78.1842 56.1055 78.0086 55.6817C77.4361 54.2995 76.3379 53.2013 74.9557 52.6288C74.5319 52.4533 73.9768 52.3316 73.0237 52.2666C72.0536 52.2004 70.8143 52.1994 69.0363 52.1994H62.2671C60.1299 52.1994 58.64 52.2009 57.4802 52.2956Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7541 55.96C56.7156 55.96 55.8738 56.8018 55.8738 57.8403C55.8738 58.8788 56.7156 59.7206 57.7541 59.7206H72.7969C73.8353 59.7206 74.6772 58.8788 74.6772 57.8403C74.6772 56.8018 73.8353 55.96 72.7969 55.96H57.7541Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7541 63.4813C56.7156 63.4813 55.8738 64.3232 55.8738 65.3617C55.8738 66.4002 56.7156 67.242 57.7541 67.242H63.3951C64.4336 67.242 65.2755 66.4002 65.2755 65.3617C65.2755 64.3232 64.4336 63.4813 63.3951 63.4813H57.7541Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_641_6822",
    x: 0.488281,
    y: 0.335938,
    width: 154.051,
    height: 154.051,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.113725 0 0 0 0 0.298039 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_641_6822"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_641_6822",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_641_6822",
    x1: 4.48721,
    y1: 64.626,
    x2: 130.641,
    y2: 64.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463DA3",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePostEvent);
export default __webpack_public_path__ + "static/media/mobile-post-event.e36c58891ab04143ff51fedaef81f289.svg";
export { ForwardRef as ReactComponent };